// The storybook kit registers a global AhaIcon, which would otherwise swallow the DS <aha-icon> tag.
export default {
  functional: true,
  render: (h, { data }) => h('aha-icon', { ...data, pre: true }),
}
